import { STATUS_TYPE } from '../../../enum';

export interface Partner {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface FindPartner {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePartner {
  name: string;
  isActive?: boolean;
}

export interface PatchPartner {
  id: string;
  name?: string;
  isActive?: boolean;
}

interface InitialState {
  data: Partner[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
